<template>
    <div class="lms__superadmin_customer_service_sso_edit_customer_setup">
        <component-wrapper>
            <form-textarea
                :label="'Paste metadata'"
                :name="'lms-superadmin-customer-service-sso-edit-customer-setup-metadata'"
                :v-validate="{ required: true }"
                :required="true"
                v-model="subscriptionMetadata"
            ></form-textarea>
            <component-title :size="'medium'">Attribute mapping override</component-title>
            <div class="lms__superadmin_customer_service_sso_edit_customer_setup_table">
                <div class="columns">
                    <div class="column is-narrow lms__superadmin_customer_service_sso_edit_customer_setup_table_left">
                        <component-title :size="'label'" :margin="'none'">Form</component-title>
                    </div>
                    <div class="column lms__superadmin_customer_service_sso_edit_customer_setup_table_right">
                        <component-title :size="'label'" :margin="'none'">SSO tool</component-title>
                    </div>
                </div>
                <div class="columns is-vcentered">
                    <div class="column is-narrow lms__superadmin_customer_service_sso_edit_customer_setup_table_left">
                        First name
                    </div>
                    <div class="column lms__superadmin_customer_service_sso_edit_customer_setup_table_right">
                        <form-text
                            :label="''"
                            :name="'lms-superadmin-customer-service-sso-edit-customer-setup-first-name'"
                            v-model="subscriptionAttributesFirstName"
                        ></form-text>
                    </div>
                </div>
                <div class="columns is-vcentered">
                    <div class="column is-narrow lms__superadmin_customer_service_sso_edit_customer_setup_table_left">
                        Last name
                    </div>
                    <div class="column lms__superadmin_customer_service_sso_edit_customer_setup_table_right">
                        <form-text
                            :label="''"
                            :name="'lms-superadmin-customer-service-sso-edit-customer-setup-last-name'"
                            v-model="subscriptionAttributesLastName"
                        ></form-text>
                    </div>
                </div>
                <div class="columns is-vcentered">
                    <div class="column is-narrow lms__superadmin_customer_service_sso_edit_customer_setup_table_left">
                        Email address
                    </div>
                    <div class="column lms__superadmin_customer_service_sso_edit_customer_setup_table_right">
                        <form-text
                            :label="''"
                            :name="'lms-superadmin-customer-service-sso-edit-customer-setup-email-address'"
                            v-model="subscriptionAttributesEmailAddress"
                        ></form-text>
                    </div>
                </div>
            </div>
        </component-wrapper>
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import PopNotify from '@/components/default/shared/PopNotify'
import { validateBeforeRouteLeave, watchContentChangeEmit } from '@/helpers/mixins'
import { User } from '@/User'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import FormTextarea from '@/components/default/forms/FormTextarea'
import FormText from '@/components/default/forms/FormText'
import ComponentWrapper from '@/components/default/shared/ComponentWrapper'

export default {
  name: 'lms-superadmin-customer-service-sso-edit-customer-setup',
  components: {
    ComponentWrapper,
    FormText,
    ComponentTitle,
    FormTextarea,
    PopNotify
  },
  data () {
    return {
      user: new User()
    }
  },
  mixins: [validateBeforeRouteLeave, watchContentChangeEmit],
  computed: {
    subscriptionMetadata: {
      get () {
        return this.$store.getters.getEbsServiceSSOMetadata
      },
      set (value) {
        this.$store.dispatch('ebsServiceSSOSetMetadata', value)
      }
    },
    subscriptionAttributesFirstName: {
      get () {
        const attributes = this.$store.getters.getEbsServiceSSOAttributes
        return attributes ? attributes.firstName : ''
      },
      set (value) {
        this.$store.dispatch('ebsServiceSSOSetAttributes', { key: 'firstName', value })
      }
    },
    subscriptionAttributesLastName: {
      get () {
        const attributes = this.$store.getters.getEbsServiceSSOAttributes
        return attributes ? attributes.lastName : ''
      },
      set (value) {
        this.$store.dispatch('ebsServiceSSOSetAttributes', { key: 'lastName', value })
      }
    },
    subscriptionAttributesEmailAddress: {
      get () {
        const attributes = this.$store.getters.getEbsServiceSSOAttributes
        return attributes ? attributes.email : ''
      },
      set (value) {
        this.$store.dispatch('ebsServiceSSOSetAttributes', { key: 'email', value })
      }
    }
  },
  methods: {},
  mounted () {

  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/customers/_lmssuperadmincustomerservicessoaddeditcustomersetup.scss";
</style>
